import React, {useState} from "react";
import ConfirmModal from "../../../components/ConfirmModal";
import {IconButton, OutlinedButton} from "../../../components/CustomButton";
import Input from "../../../components/form/Input";

export const AddCitiesModal = ({disabled, showModal, setShowModal, onAdd}) => {
  const initialCities = [{name: ""}]
  const [cities, setCities] = useState(initialCities)


  return <ConfirmModal title="Add Cities" disabled={disabled} showModal={showModal}
                       setShowModal={setShowModal}
                       buttonLabel="Add" onConfirm={() => onAdd(cities)}>
    <div>
      {
        cities.map((c, index) =>
          <div key={`cities-${c.value}-${index}`} className="relative p-4 pt-8 mb-4 border bg-secondary-100 rounded-md">
            {cities.length > 1 && (
              <div className="absolute top-2 right-2">
                <IconButton
                  onClick={() => {
                    const newCities = cities.filter(
                      (value) => value !== c
                    );
                    setCities([...newCities]);
                  }}
                />
              </div>
            )}
            <Input placeholder="City" onChange={(e) => {
              c.name = e.target.value
              setCities([...cities])
            }}/>
          </div>
        )
      }
      <div className="flex justify-end">
        <OutlinedButton
          disabled={cities.some((c) => !c.name)}
          onClick={() => {
            cities.push({
              name: ''
            });
            setCities([...cities]);
          }}
        >
          + Add more
        </OutlinedButton>
      </div>
    </div>
  </ConfirmModal>
}